import { FileTextOutlined, ProfileOutlined } from "@ant-design/icons";
import { Button, Space } from "antd";
import moment from "moment";
import { useRef } from "react";
import { useTranslation } from "react-i18next";

import { IconCheckControl } from "shared/ui/icon-check-control";
import { ContractData } from "../types";

import { generatePath, useNavigate } from "react-router-dom";
import ROUTES from "shared/routes";
import styles from "./index.module.scss";
import { SignContractModal, SignContractType } from "./sign-contract-modal";

export const ContractItem = ({ contract }: { contract: ContractData }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const signContractModalRef = useRef<SignContractType>(null);

  return (
    <div className={styles.listItem}>
      <SignContractModal ref={signContractModalRef} />
      <div className={styles.head}>
        <div className={styles.iconWrapper}>
          <FileTextOutlined />
        </div>
        <div style={{ marginRight: "auto" }}>
          {t("contracts.contract_number")} {contract?.number}
          <div className={styles.date}>
            {t("contracts.contract_date")}: <br />{" "}
            {moment(contract?.date).format("DD.MM.YYYY")}
          </div>
        </div>
      </div>
      <div>
        <div className={styles.organization}>
          <ProfileOutlined />
          {contract?.company?.name}
        </div>
        <Space vertical>
          <div className={styles.infoItem}>
            <IconCheckControl
              checked={contract?.edo_status?.type === "SUCCESS"}
              loading={contract?.edo_status?.type === "LOADING"}
            />
            {contract?.edo_status?.label}

            {contract?.sign_provider === "DTT" && (
              <Button
                type="link"
                iconPlacement="end"
                onClick={() =>
                  signContractModalRef.current?.open(contract?.number)
                }
                style={{ padding: 0 }}
              >
                {t("contracts.how_to_sign")}
              </Button>
            )}
          </div>

          <div className={styles.infoItem}>
            {(contract?.sign_provider === "SMS" ||
              contract?.sign_provider === "SMART_BRIDGE") && (
              <Button
                type="primary"
                onClick={() =>
                  navigate(
                    generatePath(ROUTES.SING_CONTRACTS_ID, {
                      contractId: contract.id,
                    }),
                  )
                }
              >
                {contract.edo_status?.code === "FINISHED"
                  ? t("contracts.view")
                  : t("contracts.view_and_sign")}
              </Button>
            )}
          </div>
        </Space>
      </div>
    </div>
  );
};
